@if (paymentsCount > 0) {
  <nz-alert
    nzType="warning"
    [nzMessage]="'ამ ვიზიტზე შენახულია ' + paymentsCount + ' გადახდა (' + totalPaid + ' ₾). გაუქმების შემთხვევაში ყველა გადახდა წაიშლება და თანხა დაუბრუნდება მომხმარებელს.'"
    nzShowIcon
    style="margin-bottom: 16px"
  ></nz-alert>
}
<form [formGroup]="form">
  <beautyapp-textarea formControlName="disableReason" placeholder="გაუქმების მიზეზი" label="გაუქმების მიზეზი"></beautyapp-textarea>
</form>
<div *nzModalFooter>
  <nz-space>
    <button
      *nzSpaceItem
      nz-button
      nzType="default"
      (click)="modal.close()"
    >
      დახურვა
    </button>
    <button
      *nzSpaceItem
      nz-button
      [nzLoading]="isLoading"
      nzDanger
      type="button"
      (click)="deleteBooking()"
    >
      დადასტურება
    </button>
  </nz-space>

</div>
